import { render, staticRenderFns } from "./PaidUser.vue?vue&type=template&id=56eb8a01"
import script from "./PaidUser.vue?vue&type=script&lang=js"
export * from "./PaidUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports